import $ from 'jquery';
import {Collapse} from "bootstrap";


const $body = $('body');
const inBackend = $body.hasClass('neos-backend');


$(function () {


    $('.swapper').each(function () {

        if (inBackend) return;

        const $swapper = $(this);
        const $swapperImageContainer = $swapper.find('.swapper-image-container');

        const $swapperItems = $swapper.find('.swapper-item');
        const $imageWrappers = $swapper.find('.swapper-item-image-wrapper');

        let swapPoint = getSwapPoint();
        let $activeItem = null;


        // Move images to container and save target for later
        $swapperItems.each(function () {
            const $swapperItem = $(this);
            const $imageWrapper = $swapperItem.find('.swapper-item-image-wrapper');

            $swapperItem.data('image-target', $imageWrapper);

            $swapperImageContainer.append($imageWrapper);
        });

        // Init
        calculateActiveElement();



        // Handle scroll
        $(window).on('scroll', function () {
            calculateActiveElement();
        });


        // Handle window resize
        $(window).on('resize', function () {
            swapPoint = getSwapPoint();
            calculateActiveElement();
        });


        // Calculate which item is active and reveal image
        function calculateActiveElement() {
            // First item has to be active by default
            $activeItem =  $swapperItems.first();

            $swapperItems.each(function () {

                const $swapperItem = $(this);

                // Get element y-position on screen
                const swapperItemTop = $swapperItem[0].getBoundingClientRect().top;

                // Find active element
                if (swapperItemTop < swapPoint) {
                    $activeItem = $swapperItem;
                }
            });

            revealImageFromItem($activeItem);
        }



        // Calculate swap point slighty above center of screen
        function getSwapPoint() {
            return $(window).height() * 0.5;
        }


        // Finds related image and reveals it
        function revealImageFromItem($swapperItem) {

            // Check if item is already active
            if ($swapperItem.data('is-active')) {
                return;
            }

            // Save active state for reducing computing
            $swapperItems.data('is-active', false);
            $swapperItem.data('is-active', true);

            // Actually reveal image
            const $target = $swapperItem.data('image-target');
            $imageWrappers.removeClass('show');
            $target.addClass('show');
        }


    });
});
